var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-drawer',{attrs:{"title":"消息中心","visible":_vm.drawer,"direction":_vm.direction,"before-close":_vm.$f.openOrcloseMsg},on:{"update:visible":function($event){_vm.drawer=$event}}},[_c('span',[_vm._v("我来啦!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }